import * as React from 'react';

import * as styles from './IconDontKnowMan.css';

export const IconDontKnowMan: React.FC = () => <div className={styles['dont-know-man-icon']} />;

IconDontKnowMan.displayName = 'IconDontKnowMan';
